<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content>
  <p class="text-gray-600 mb-2">
    Project: <strong>{{ data.projectName }}</strong>
  </p>
  <p class="text-sm text-gray-500 mb-4">Current status: {{ data.currentStatus }}</p>

  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>{{ data.action === 'submit' ? 'Submission notes (optional)' : 'Approval notes' }}</mat-label>
      <textarea matInput rows="4" formControlName="notes"></textarea>
      <mat-error *ngIf="form.get('notes')?.hasError('required')">Notes are required</mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="confirm()" [disabled]="form.invalid">
    Confirm
  </button>
</mat-dialog-actions>
